import { render, staticRenderFns } from "./ModalConfirmarEdicao.vue?vue&type=template&id=b5e0c24e"
import script from "./ModalConfirmarEdicao.vue?vue&type=script&lang=js"
export * from "./ModalConfirmarEdicao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports